import { Modal } from 'react-bootstrap';
import Button from 'components/base/Button';
import { Department } from 'store/departmentmanagementSlice';

interface Props {
  show: boolean;
  handleClose: () => void;
  dept: Department;
  onDeleted: () => void;
}

const DeleteDepartmentModal = ({
  show,
  handleClose,
  dept,
  onDeleted
}: Props) => (
  <Modal show={show} onHide={handleClose} centered>
    <Modal.Header closeButton>
      <Modal.Title>Delete Department</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to delete <strong>{dept.name}</strong>?
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Cancel
      </Button>
      <Button variant="danger" onClick={onDeleted}>
        Delete
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteDepartmentModal;
